import React, { ReactHTML } from "react";

export type TitleCutBackground = "white" | "gray-background" | "dark" | "gray";

interface TitleCutProps {
	children?: any;
	className?: string;
	color: TitleCutBackground;
	as: keyof ReactHTML;
}

const TitleCut = ({ children, className, color, as }: TitleCutProps) => {
	const Text = as;
	return (
		<div className={`relative block overflow-hidden ${className || ""}`}>
			<Text className="whitespace-nowrap">{children}</Text>
			<div
				className={`absolute top-0 right-0 w-24 bottom-0 bg-gradient-to-l from-${color}`}
			></div>
		</div>
	);
};

TitleCut.defaultProps = {
	color: "white",
	as: "p",
};

export default TitleCut;
